import {
  AiListingAddPhotosEvent,
  AiListingBannedBrandEvent,
  AiListingDeletePhotoEvent,
  AiListingDescriptionEvent,
  AiListingErrorEvent,
  AiListingFieldSaveEvent,
  AiListingFieldEditEvent,
  AiListingFormSubmitEvent,
  AiListingLeaveConfirmationEvent,
  AiListingMeasurementGuideEvent,
  AiListingModelEvent,
  AiListingPhotoReorderEvent,
  AiListingPurchaseInformationEvent,
  AiListingScanEvent,
  AiListingSellButtonEvent,
  AiListingSizeEvent,
  AiListingStartEvent,
  AiListingTypeaheadSelectEvent,
  AiListingViewDraftsEvent,
  AiListingViewGuidelinesEvent,
} from '@interfaces/models/internal/analytics-event/ai-listing-event';

export const aiListingStartEventPayload: Omit<AiListingStartEvent, 'action'> = {
  event: 'ai_listing',
  category: 'listing_start',
};

export const aiListingScanEventPayload: AiListingScanEvent = {
  event: 'ai_listing',
  category: 'ai_listing',
  action: 'ai_scanning',
};

export const aiListingAddPhotosEventPayload: AiListingAddPhotosEvent = {
  event: 'ai_listing',
  category: 'ai_listing',
  action: 'add_photos',
  label: 'photo_step',
};

export const aiListingPhotoReorderEventPayload: Omit<AiListingPhotoReorderEvent, 'label' | 'value'> = {
  event: 'ai_listing',
  category: 'ai_listing',
  action: 'photo_reorder',
};

export const aiListingLeaveConfirmationEventPayload: Omit<AiListingLeaveConfirmationEvent, 'action' | 'label'> = {
  event: 'ai_listing',
  category: 'ai_listing',
};

export const aiListingFieldEditEventPayload: Omit<AiListingFieldEditEvent, 'action' | 'label'> = {
  event: 'ai_listing',
  category: 'ai_listing',
};

export const aiListingDescriptionEventPayload: Omit<AiListingDescriptionEvent, 'label'> = {
  event: 'ai_listing',
  category: 'ai_listing',
  action: 'description',
};

export const aiListingFormSubmitEventPayload: Omit<AiListingFormSubmitEvent, 'action'> = {
  event: 'ai_listing',
  category: 'ai_listing',
};

export const aiListingSellButtonEventPayload: AiListingSellButtonEvent = {
  event: 'ai_listing',
  category: 'sell',
  action: 'sell_an_item',
  label: 'listing_start_popup',
};

export const aiListingViewDraftsEventPayload: AiListingViewDraftsEvent = {
  event: 'ai_listing',
  category: 'listing_start',
  action: 'manual_listing',
  label: 'view_drafts',
};

export const aiListingViewGuidelinesEventPayload: AiListingViewGuidelinesEvent = {
  event: 'ai_listing',
  category: 'ai_listing',
  action: 'add_photos',
  label: 'view_guidelines',
};

export const aiListingDeletePhotoEventPayload: Omit<AiListingDeletePhotoEvent, 'label'> = {
  event: 'ai_listing',
  category: 'ai_listing',
  action: 'delete_photo',
};

export const aiListingErrorEventPayload: Omit<AiListingErrorEvent, 'label'> = {
  event: 'ai_listing',
  category: 'ai_listing',
  action: 'error',
};

export const aiListingTypeaheadSelectEventPayload: Omit<
  AiListingTypeaheadSelectEvent,
  'action' | 'label' | 'property'
> = {
  event: 'ai_listing',
  category: 'ai_listing',
};

export const aiListingFieldSaveEventPayload: Omit<AiListingFieldSaveEvent, 'action' | 'label' | 'property'> = {
  event: 'ai_listing',
  category: 'ai_listing',
};

export const aiListingMeasurementGuideEventPayload: AiListingMeasurementGuideEvent = {
  event: 'ai_listing',
  category: 'ai_listing',
  action: 'dimensions',
  label: 'measurement_guide',
};

export const aiListingSizeEventPayload: Omit<AiListingSizeEvent, 'label'> = {
  event: 'ai_listing',
  category: 'ai_listing',
  action: 'size',
};

export const aiListingModelEventPayload: Omit<AiListingModelEvent, 'label'> = {
  event: 'ai_listing',
  category: 'ai_listing',
  action: 'model',
};

export const aiListingPurchaseInformationEventPayload: Omit<AiListingPurchaseInformationEvent, 'label' | 'property'> = {
  event: 'ai_listing',
  category: 'ai_listing',
  action: 'purchase_information',
};

export const aiListingBannedBrandEventPayload: Omit<AiListingBannedBrandEvent, 'property'> = {
  event: 'ai_listing',
  category: 'ai_listing',
  action: 'brand',
  label: 'not_accepted_brand',
};
